export default __webpack_public_path__ + "static/media/BoomOnBoat.5e0167da.jpg";